import { Ripple } from "@maxhub/max-ui"

export const RippleExample = {
    title: 'Ripple',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [],

    Preview({ props }){
        return (
            <div
                style={{
                    border: '2px solid',
                    height: 200,
                    overflow: 'hidden',
                    position: 'relative',
                    width: 200,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    userSelect: 'none',
                    cursor: 'pointer',
                }}
            >
                Нажимай на меня!!!
                <Ripple
                    style={{
                        inset: 0,
                        position: 'absolute'
                    }}
                />
            </div>
        )
    },

    getCode(){
        return `<div
  style={{
    border: '2px solid',
    height: 200,
    overflow: 'hidden',
    position: 'relative',
    width: 200
  }}
>
  Нажимай на меня!!!
  <Ripple
    style={{
      inset: 0,
      position: 'absolute'
    }}
   />
</div>`
    }

}